import React, { useEffect, useState } from 'react'
import { findBrandNames, findDrug } from '../../../drugData/lookupDrugs';
import { medsCreateState, createMedsStep } from 'store/storeValtio';

export default function MedicationBrand({prevStep, nextStep}) {
  //console.log('MedicationBrand', medsCreateState);
  const [brand,setBrand] = useState(medsCreateState.brand);
  const [brandNames, setBrandNames] = useState([]);

  useEffect(() => {
    const brand = medsCreateState.brand;
    const names = findBrandNames(medsCreateState.name);
    //console.log('brand', brand, names);
    const notIn = brand && brand.length > 0 && !(names.some(n => n.name === brand));
    if (notIn) {
      let item = {
        'name': brand,
        'class': 'N',
        'id': '0'
      }
      names.unshift(item);
    }
    let item = {
      'name': 'Not Listed',
      'class': 'N',
      'id': '0'
    }
    names.push(item);

    setBrandNames(names)
    //console.log('brands UE', names);
  },[]);

  function selectBrand(b) {
    //let name = medsCreateState.name;
    //console.log('selectBrand', medsCreateState.orangeId, b);
    medsCreateState.class = b.class;
    if (b.name === 'Not Listed') {
      const d = findDrug(medsCreateState.name, medsCreateState.name );
      //console.log('drug found', d);
      if (d) medsCreateState.orangeId = d.id;
      medsCreateState.brand = '';    
    } else {
      medsCreateState.brand = b.name;
      //medsCreateState.type = b.type;
      if (b.id !== '0') medsCreateState.orangeId = b.id;
    }
    nextStep(createMedsStep.type);
  }

  function brandChange(e) {
    //console.log('brandChange', e.target.value);
    const txt = e.target.value;
    const tu = txt.toUpperCase();
    setBrand(tu);
    const names = findBrandNames(medsCreateState.name);
    // if the current name is not in the list, add it at the top
    const b = medsCreateState.brand;
    let notIn = b.length > 0 && !(names.some(n => n.name === b));
    if (notIn) {
      const item = {
        'name': medsCreateState.brand,
        'type': '',
        'class': 'N',
        'id': '0'
      }
      names.unshift(item);
    }

    // if the new name is not in the list, add it at the top
    notIn = tu.length > 0 && !(names.some(n => n.name === tu));
    if (notIn) {
      const item = {
        'name': tu,
        'type': '',
        'class': 'N',
        'id': '0'
      }
      names.unshift(item);
    }
  
    const item = {
      'name': 'Not Listed',
      'type': '',
      'class': 'N',
      'id': '0'
    }
    names.push(item);

    //console.log('names',names)
    setBrandNames(names);
  }

  return (
    <>
      <div className='medBody'>
        What is the <b>brand</b> of your medication?
      </div>
      <div className='medName'>
        <input 
          autoFocus 
          value={brand} 
          onChange={(e)=>brandChange(e)} 
          className='medInput' 
          id='brand_name' 
          name='brand_name' 
          type='text' 
          autoComplete='off' 
          required /> 
      </div>
      <div className='medList'>
        {brandNames.map((bn,ix) => {
          const b = medsCreateState.brand;
          const li = ( (b && b.length === 0 && bn.name === 'Not Listed') || bn.name === b) ? 'py-1 bg-green-300' : 'py-1 bg-slate-300';
          //const li = bn.name === medsCreateState.brand ? 'py-1 bg-green-300' : 'py-1 bg-slate-300';
          return (
            <div
              key={ix} 
              className={'medCard ' + li} 
              onClick={()=>selectBrand(bn)} >
              {bn.name}
            </div>
            )
          })
        }
      </div>
    </>
    );
  }
